module.exports = __webpack_public_path__ + "static/img/1_13_1.f35a0da3.jpg";